<template>
  <div>
    <table class="invoice-header">
      <thead>
        <tr style="height: 70px">
          <th class="header-left-section">
            <p class="header-top-left-text">{{ headerData.company_name_en }}</p>
            <p class="header-bottom-text">{{ headerData.outlet_slogan_en }}</p>
          </th>
          <th class="header-middle-section">
            <img
              width="120"
              height="60"
              style="object-fit: cover;"
              :src="
                headerData.attachment
                  ? `${baseUrls.images}/${headerData.attachment}`
                  : `${baseUrls.images}/invoiceLogo.png`
              "
            />
          </th>
          <th class="header-right-section">
            <p class="header-top-right-text">
              {{ headerData.company_name_ar }}
            </p>
            <p class="header-bottom-text">{{ headerData.outlet_slogan_ar }}</p>
          </th>
        </tr>
      </thead>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      authUserData: 'auth/getAuthUserData'
    })
  },

  data() {
    return {
      headerData: {
        company_name_en: '',
        company_name_ar: '',
        outlet_slogan_en: '',
        outlet_slogan_ar: '',
        attachment: ''
      }
    }
  },

  watch: {
    authUserData: {
      immediate: true,
      handler() {
        if (this.authUserData.constructor === Object && Object.keys(this.authUserData).length !== 0) {
          this.headerData.company_name_en = this.authUserData.outlet_info.company_name_en
          this.headerData.company_name_ar = this.authUserData.outlet_info.company_name_ar
          this.headerData.outlet_slogan_en = this.authUserData.outlet_info.outlet_slogan_en
          this.headerData.outlet_slogan_ar = this.authUserData.outlet_info.outlet_slogan_ar
          this.headerData.attachment = this.authUserData.outlet_info.attachment
        }
      }
    }
  }
}
</script>

<style>
.invoice-header {
  position: fixed;
  top: 0;
  left: 0;
  border-collapse: separate;
  border-spacing: 0;
  border: 2px solid #172653;
  border-radius: 2px;
  -moz-border-radius: 5px;
  width: 100%;
  padding: 5px;
}
.header-top-left-text {
  font-size: 20px;
  font-weight: bold;
  margin: 0px;
  color: #17124e;
  -webkit-print-color-adjust: exact;
}
.header-bottom-text {
  margin: 0px;
  margin-top: 5px;
  color: #17124e;
  -webkit-print-color-adjust: exact;
}
.header-top-right-text {
  font-size: 22px;
  font-weight: bold;
  margin: 0px;
  color: #17124e;
  -webkit-print-color-adjust: exact;
}
.header-left-section {
  width: 300px;
  text-align: left;
}
.header-right-section {
  width: 300px;
  text-align: right;
}
.header-middle-section {
  width: 120px;
}
</style>
